import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { FormControl } from '@angular/forms';

import { GenericListUICDTO, GenericListUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { PurchaseReleaseDetailDTO } from 'src/app/purchase/purchase-release/purchase-release-detail/purchase-release-detail.interface';
import { PurchaseReleaseDetailService } from 'src/app/purchase/purchase-release/purchase-release-detail/purchase-release-detail.service';
import { PurchaseReleaseDTO, PurchaseReleaseSearchByReleaseNoRequestDTO } from 'src/app/purchase/purchase-release/purchase-release.interface';
import { PurchaseReleaseService } from 'src/app/purchase/purchase-release/purchase-release.service';

@Component({
  selector: 'app-add-via-purchase-release-reference-button',
  templateUrl: './add-via-purchase-release-reference-button.component.html',
  styleUrls: ['./add-via-purchase-release-reference-button.component.css']
})
export class AddViaPurchaseReleaseReferenceButtonComponent implements OnInit {

  ngOnInit(): void {
    this.PurchaseReleaseNo.valueChanges.subscribe(res => {
      console.log(res);
      if (res !== null && res !== undefined && res !== '' && Number(res) >= 1) {
        this.GetItemsByPurchaseReleaseId(Number(res))
      }
    })

    this.GetTableUI()
  }

  @Output() onSubmit: EventEmitter<PurchaseReleaseDetailDTO[]> = new EventEmitter<PurchaseReleaseDetailDTO[]>();

  @Input({ required: true }) MasterId: number = 0
  @Input({ required: true }) MasterType: string = ''

  gListUICService = inject(GenericListUicService);
  ReleaseItems: PurchaseReleaseDetailDTO[] = [];
  SelectedReleaseItems: PurchaseReleaseDetailDTO[] = [];
  @Input() EnablePriceEdit: boolean = false



  purchaseReleaseService = inject(PurchaseReleaseService)
  purchaseReleaseDetailService = inject(PurchaseReleaseDetailService)
  User = inject(UserLoginService).User()
  PurchaseReleaseList: PurchaseReleaseDTO[] = [];
  prdListUIC: GenericListUICDTO[] = []
  dataLoading: boolean = false
  submitResults() {
    this.isSubmitting = true
    this.onSubmit.emit(this.SelectedReleaseItems)

  }

  PurchaseReleaseNo = new FormControl('')

  title = 'Purchase Release'
  ReleaseModalRef!: NgbModalRef
  isSubmitting: boolean = false
  @ViewChild('ReleaseItemModal', { static: true }) ReleaseModalTemplate!: ElementRef

  modalService = inject(NgbModal)
  searchLoading: boolean = false;

  openModal() {
    this.PurchaseReleaseNo.reset()
    this.ReleaseItems = []
    this.SelectedReleaseItems = []
    this.PurchaseReleaseList = []
    this.searchLoading = true;
    let data: PurchaseReleaseSearchByReleaseNoRequestDTO = {
      releaseNo: '',
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }
    this.purchaseReleaseService.PurchaseRelease_SearchByReleaseNo(data).subscribe(res => {
      this.PurchaseReleaseList = res.items
      this.searchLoading = false;
    })
    this.ReleaseModalRef = this.modalService.open(this.ReleaseModalTemplate, { size: 'lg', backdrop: 'static' })
  }

  SearchPurchaseRelease(event: { term: string; items: any[]; }) {
    console.log(event.term);
    setTimeout(() => {
      this.searchLoading = true;

      let data: PurchaseReleaseSearchByReleaseNoRequestDTO = {
        releaseNo: event.term,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId
      }
      this.purchaseReleaseService.PurchaseRelease_SearchByReleaseNo(data).subscribe(res => {
        this.PurchaseReleaseList = res.items
        this.searchLoading = false;
      })
    }, 500);
  }


  GetItemsByPurchaseReleaseId(releaseId: number) {
    this.dataLoading = true
    // Switching release: drop ticks from the previous one so they aren't imported with this one
    this.SelectedReleaseItems = []
    let payload = {

      releaseId,
      masterId: this.MasterId,
      masterType: this.MasterType,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }
    this.purchaseReleaseDetailService.PurchaseReleaseDetail_ReadByReleaseIdForImport(payload).subscribe(res => {
      this.ReleaseItems = res.items
      this.dataLoading = false

    })
  }

  GetTableUI() {
    let data: GenericListUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.PurchaseReleaseDetailList,
      tenantId: this.User.companyId
    }

    this.gListUICService.GenericListUIC_ReadByTenantId(data).subscribe(res => {
      this.prdListUIC = res.items
    })
  }


  handleItemSelection(event: { checkstate: boolean; data: PurchaseReleaseDetailDTO; }) {
    event.data.isSelected = event.checkstate
  }

  onSelctionCheckboxChange(event: any, item: PurchaseReleaseDetailDTO) {
    item.isSelected = event.target.checked
    let isDuplicate = this.SelectedReleaseItems.find(i => i.itemId == item.itemId)

    if (event.target.checked) {
      if (!isDuplicate)
        this.SelectedReleaseItems.push(item)
    } else {
      this.SelectedReleaseItems = this.SelectedReleaseItems.filter(i => i.itemId != item.itemId)
    }

    console.log(this.SelectedReleaseItems);
  }


  onSelectAllCheckboxChange(event: any) {
    if (event.target.checked) {
      // Clear previous selections
      this.SelectedReleaseItems = [];

      // Mark all items as selected
      this.ReleaseItems.forEach(i => i.isSelected = true);

      // Copy all items into SelectedReleaseItems
      this.SelectedReleaseItems = [...this.ReleaseItems];
    } else {
      // Uncheck all
      this.ReleaseItems.forEach(i => i.isSelected = false);
      this.SelectedReleaseItems = [];
    }
    console.log(this.SelectedReleaseItems);
  }


  get ifItemsSelected() {
    return this.SelectedReleaseItems.length > 0
  }

  patchCommonPrice(event: Event) {
    const numValue = Number((event.target as HTMLInputElement).value);
    this.ReleaseItems.forEach(i => {
      if (i.isSelected) i.price = numValue;
    });
  }
}
